import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Check, Truck, Car, Star } from 'lucide-react';
import { packages } from '../data/mock';

const Packages = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getIcon = (name) => {
    if (name.includes('Drop-Off')) return <Truck className="w-6 h-6" />;
    return <Car className="w-6 h-6" />;
  };

  return (
    <section id="packages" className="section-padding bg-black relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 grid-pattern opacity-30" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="accent-line mx-auto mb-6" />
          <h2 className="section-title text-white mb-4">All-Day Booth Rentals</h2>
          <p className="subtitle max-w-2xl mx-auto">
            Choose the package that fits your needs. Both options include unlimited photos and digital gallery access.
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {packages.map((pkg, index) => (
            <Card
              key={pkg.id}
              className={`relative bg-gray-900 border-gray-800 hover:border-cyan-500/50 transition-all duration-300 overflow-hidden ${
                pkg.popular ? 'ring-2 ring-cyan-500' : ''
              }`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="absolute top-4 right-4">
                  <div className="flex items-center bg-cyan-500 text-black text-xs font-bold px-3 py-1 rounded-full">
                    <Star className="w-3 h-3 mr-1" />
                    POPULAR
                  </div>
                </div>
              )}

              <CardHeader className="pb-4">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-3 bg-gray-800 rounded-lg text-cyan-400">
                    {getIcon(pkg.name)}
                  </div>
                  <CardTitle className="text-2xl text-white font-display">
                    {pkg.name}
                  </CardTitle>
                </div>
                <CardDescription className="text-gray-400 text-base">
                  {pkg.description}
                </CardDescription>
              </CardHeader>

              <CardContent>
                {/* Price */}
                <div className="mb-6">
                  <span className="text-5xl font-bold text-white font-display">${pkg.price}</span>
                  <span className="text-gray-500 ml-2">/ all-day rental</span>
                </div>

                {/* Features */}
                <ul className="space-y-3 mb-8">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <Check className="w-5 h-5 text-cyan-400 mr-3 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Button
                  onClick={scrollToContact}
                  className={`w-full py-6 font-semibold text-lg ${
                    pkg.popular
                      ? 'bg-cyan-500 hover:bg-cyan-600 text-black'
                      : 'bg-gray-800 hover:bg-gray-700 text-white'
                  }`}
                >
                  Book This Package
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Note */}
        <p className="text-center text-gray-500 mt-8">
          All upgrades available for an additional fee. Contact us for custom quotes.
        </p>
      </div>
    </section>
  );
};

export default Packages;
